export default __webpack_public_path__ + "static/media/mulberry-logo.723b2591.svg";